export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10703.5998bd17.jpg";